module.exports = __webpack_public_path__ + "static/homeQuote1-e8ad01163923b8d243ca3bb8cf7d438c.png";